/**
 * Labstep
 *
 * @module components/ExperimentWorkflow/Action/Print
 * @desc Action to print an experiment workflow
 */

import EntityActionPrint from 'labstep-web/components/Entity/Action/Print';
import type React from 'react';
import type { PurchaseOrderActionPrintProps } from './types';

export const PurchaseOrderActionPrint: React.FC<
  PurchaseOrderActionPrintProps
> = ({ purchaseOrder }) => (
  <EntityActionPrint entity={purchaseOrder} />
);
